import React, { useImperativeHandle } from "react";
import Box from '@material-ui/core/Box';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Calendar from 'react-calendar';
import CxIconButton from "./CxIconButton";

// Importación de funciones auxiliares propias
import * as FxDat from '../fx/FxDat';

// Estilos de la librería y generales
import '../../styles/PickerDate/PickerDate.css';
import '../../styles/main.css';
import '../../styles/ReactCalendar/ReactCalendar.css';

const useStyles = makeStyles((theme) => ({
  dlgTitle: {
    backgroundColor: 'var(--ibs_color_cy_blue)',
    color: 'var(--ibs_color_white)',
    padding: '12px !important',
    "& .MuiTypography-h6": {
      fontSize: '16px',
    },
    "& .MuiIconButton-root": {
      padding: '0px',
    },
  },
  dlgContent: {
    padding: '0px 0 0px 0', 
    overflow: 'hidden',      
    minHeight: '320px', 
    boxSizing: 'border-box',
  },
  calendarWrapper: {
    "& .react-calendar": {
      border: 'none',        
      boxShadow: 'none',     
      fontFamily: 'inherit',
    },
    // ---- MODIFICACIONES PARA LIMPIAR LOS BOTONES DE MOVIMIENTO ----
    "& .react-calendar__navigation": {
      marginBottom: '0px',
      "& button": {
        minWidth: '44px',
        background: 'none !important', // Elimina fondos por defecto
        // Quita el recuadro gris cuando el botón está enfocado o activo
        "&:disabled": {
          background: 'none !important',
        },
        "&:enabled:focus": {
          background: 'none !important',
          backgroundColor: 'transparent !important',
        },
        "&:enabled:active": {
          background: 'none !important',
          backgroundColor: 'transparent !important',
        }
      },
    },
    // Evita que el botón del año/mes actual se quede gris si se navega ahí
    "& .react-calendar__navigation__button--active": {
      background: 'none !important',
      backgroundColor: 'transparent !important',
    },
    // -------------------------------------------------------------
    
    "& .react-calendar__month-view": {
      display: 'block', 
    },
    "& .react-calendar__tile": {
      height: '40px !important', 
      maxHeight: '40px !important',
      boxSizing: 'border-box',
    }
  },
  dlgButton: {
    color: 'var(--ibs_color_white)',
    '&:hover': { backgroundColor: 'transparent' },
  },
}));

const CxDlgCalendar = (props) => {
  const classes = useStyles(props);
  const { onClose, open, title, xref, ...rest } = props;

  const [date, setDate] = React.useState(new Date());
  const r_cal = React.useRef(null);

  // Exponer métodos al padre mediante la ref xref
  useImperativeHandle(xref, () => ({
    getType: () => 'CxDlgCalendar',
  }));

  const createLabel = (e) => {
    return FxDat.toMMMYYYY(e.locale, e.date).toUpperCase();
  };

  const dateSelected = (newDate) => {
    setDate(newDate);
    const dtSelected = FxDat.toIso(newDate);
    onClose(dtSelected);
  };

  return (
    <Dialog 
      open={open} 
      onClose={() => onClose(null)} 
      {...rest}
    >
      <DialogTitle className={classes.dlgTitle}>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>{title}</Box>
          <Box>
            <CxIconButton 
              type="close" 
              classType={classes.dlgButton} 
              onClick={() => onClose(null)} 
            />
          </Box>
        </Box>
      </DialogTitle>
      
      <DialogContent className={`${classes.dlgContent} ${classes.calendarWrapper}`}>
        <Calendar
          ref={r_cal}
          onChange={dateSelected}
          value={null}               
          activeStartDate={date}     
          onActiveStartDateChange={({ activeStartDate }) => setDate(activeStartDate)} 
          navigationLabel={createLabel}
          locale="es-ES" 
          showNeighboringMonth={true} 
          fixedWeekCount={true}       
        />
      </DialogContent>
    </Dialog>
  );
};

export default CxDlgCalendar;